import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { http } from "@/lib/api";

const SiteContext = createContext({ settings: {}, refresh: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const refresh = () => http.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  useEffect(() => { refresh(); }, []);
  return <SiteContext.Provider value={{ settings, refresh }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export const whatsappLink = (number, text) => {
  const digits = (number || "").replace(/[^\d]/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text || "Hello Grey Wolfe, I'd like to make an enquiry.")}`;
};

// Wolfe Realtors pages (incl. shortlets) use the Realtors line; every other page uses the Grey Wolfe line.
const isRealty = (pathname) => /^\/(realty|shortlets|booking)/.test(pathname);

export const useWhatsAppNumber = () => {
  const { settings } = useSite();
  const { pathname } = useLocation();
  const realty = isRealty(pathname);
  return realty ? settings.whatsapp_realtors || settings.whatsapp_number : settings.whatsapp_number;
};

export const defaultWhatsAppText = (pathname) =>
  isRealty(pathname)
    ? "Hello Wolfe Realtors, I'd like to make an enquiry."
    : pathname.startsWith("/development")
      ? "Hello Grey Wolfe Development, I'd like to make an enquiry."
      : pathname.startsWith("/oil-gas")
        ? "Hello Grey Wolfe Limited, I'd like to make an enquiry."
        : "Hello Grey Wolfe, I'd like to make an enquiry.";
